/* ── Partners — strip de aseguradoras ─────────────────────────────────────
   Cambio pedido por el cliente: en lugar de los wordmarks monocromos del
   handoff, cada aseguradora usa sus colores de marca reales aproximados:
   GNP naranja #FF6B00 / azul marino · HDI verde #006B2D ·
   Quálitas morado #62259D · Chubb negro.
   Se conserva tamaño/espaciado del diseño (.plogo) y la transición de hover
   (.25s); en hover el wordmark pasa a intensidad plena. */

const BRAND_CSS = `
.lp2 .partners .plogo { opacity: .82; filter: saturate(.92); }
.lp2 .partners .plogo:hover { opacity: 1; filter: saturate(1); }
.lp2 .partners .plogo.p-gnp { color: #FF6B00; }
.lp2 .partners .plogo.p-gnp:hover { color: #FF6B00; }
.lp2 .partners .plogo.p-gnp .p-sub { font-size: .46em; font-weight: 600; letter-spacing: .14em; text-transform: uppercase; color: #002D62; margin-left: .45em; vertical-align: .18em; }
.lp2 .partners .plogo.p-hdi { color: #006B2D; }
.lp2 .partners .plogo.p-hdi:hover { color: #006B2D; }
.lp2 .partners .plogo.p-qualitas { color: #62259D; }
.lp2 .partners .plogo.p-qualitas:hover { color: #62259D; }
.lp2 .partners .plogo.p-chubb { color: #000; letter-spacing: .12em; }
.lp2 .partners .plogo.p-chubb:hover { color: #000; }
`;

const Partners = () => (
  <section className="partners">
    <style>{BRAND_CSS}</style>
    <div className="inner">
      <div className="lab">Tu auto siempre protegido con</div>
      <div className="logos">
        <span className="plogo p-gnp" aria-label="GNP Seguros">GNP<span className="p-sub" aria-hidden="true">Seguros</span></span>
        <span className="plogo p-hdi" aria-label="HDI Seguros">HDI</span>
        <span className="plogo p-qualitas" aria-label="Quálitas">Quálitas</span>
        <span className="plogo p-chubb" aria-label="Chubb">CHUBB</span>
      </div>
    </div>
  </section>
);

export default Partners;
